/**
 * Personen-Import aus CSV/XLSX (F-104) – Beschriftungen und reine Hilfsfunktionen für die Oberfläche.
 * Prüfung, Dublettenerkennung und Entscheidungsvorschläge macht ausschließlich das Backend.
 */

/** party_imports.status */
export const PARTY_IMPORT_STATUS = {
  uploaded: { label: 'Hochgeladen', variant: 'neutral' },
  previewed: { label: 'Vorschau bereit', variant: 'info' },
  queued: { label: 'Wartend', variant: 'neutral' },
  processing: { label: 'Läuft', variant: 'info' },
  completed: { label: 'Abgeschlossen', variant: 'success' },
  failed: { label: 'Fehlgeschlagen', variant: 'destructive' },
};

/** party_import_rows.decision */
export const PARTY_IMPORT_DECISION_LABELS = { create: 'Neu anlegen', update: 'Bestehende aktualisieren', skip: 'Überspringen' };

/** party_import_rows.result */
export const PARTY_IMPORT_RESULT_LABELS = { created: 'Angelegt', updated: 'Aktualisiert', skipped: 'Übersprungen', failed: 'Fehlgeschlagen' };

/** Gründe eines Dublettenkandidaten */
export const DUPLICATE_REASON_LABELS = { email: 'gleiche E-Mail', name_postal_code: 'gleicher Name + PLZ' };

/** Zeilenfilter der Vorschau (filter[status]) */
export const PARTY_IMPORT_ROW_FILTERS = {
  error: 'Mit Fehlern',
  warning: 'Mit Hinweisen',
  duplicate: 'Mögliche Dubletten',
  create: 'Neu anlegen',
  update: 'Aktualisieren',
  skip: 'Überspringen',
  failed: 'Fehlgeschlagen',
};

/** Trennzeichen (CSV) */
export const DELIMITER_LABELS = { ';': 'Semikolon (;)', ',': 'Komma (,)', '\t': 'Tabulator', '|': 'Senkrechter Strich (|)' };

/**
 * Hinweise zur Spaltenzuordnung, bevor sie an die API geht (UX – die API prüft erneut).
 * @param {Record<string, string|null|undefined>} mapping  Spaltenindex → Feld
 * @returns {string[]}
 */
export function mappingProblems(mapping) {
  const fields = Object.values(mapping ?? {}).filter((f) => typeof f === 'string' && f !== '');
  const problems = [];
  if (!fields.includes('last_name') && !fields.includes('organization_name')) {
    problems.push('Bitte mindestens „Nachname“ oder „Organisation / Firma“ zuordnen.');
  }
  const duplicates = [...new Set(fields.filter((f, i) => fields.indexOf(f) !== i))];
  if (duplicates.length > 0) problems.push('Jedes Zielfeld darf nur einer Spalte zugeordnet werden.');
  return problems;
}

/**
 * Schritt des Assistenten aus dem Import-Status.
 * @param {string|undefined} status
 * @returns {'mapping'|'preview'|'result'}
 */
export function importStep(status) {
  if (status === 'previewed') return 'preview';
  if (status === 'queued' || status === 'processing' || status === 'completed' || status === 'failed') return 'result';
  return 'mapping';
}

/**
 * Anzeigename der Zeile aus den normalisierten Werten.
 * @param {Record<string, any>|undefined} values
 */
export function importRowName(values) {
  if (!values) return '';
  const person = [values.title, values.first_name, values.last_name].filter(Boolean).join(' ');
  return person || values.organization_name || '';
}

/**
 * Einzeilige Anschrift aus den normalisierten Werten.
 * @param {Record<string, any>|undefined} values
 */
export function importRowAddress(values) {
  if (!values) return '';
  const street = [values.street, values.house_number].filter(Boolean).join(' ');
  const city = [values.postal_code, values.city].filter(Boolean).join(' ');
  return [street, city, values.country && values.country !== 'DE' ? values.country : null].filter(Boolean).join(', ');
}
